import { PricingInfo } from "./PricingInfo.js";
import { HorizontalDivider, Stack } from "@myphx-engineering/phx-design-system";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";

//#region src/components/pricing-info/PricingInfoList.tsx
const PricingInfoList = ({ pricing }) => {
	return /* @__PURE__ */ jsx(Fragment, { children: pricing.map((info, index) => {
		return /* @__PURE__ */ jsxs(Stack, {
			gap: "sm",
			children: [/* @__PURE__ */ jsx(PricingInfo, {
				option: info?.option,
				details: info?.details,
				value: info?.value
			}), index !== pricing.length - 1 ? /* @__PURE__ */ jsx(HorizontalDivider, {}) : null]
		}, `${info?.option}-${index}`);
	}) });
};

//#endregion
export { PricingInfoList };